import { supabase } from '@/integrations/supabase/client';

export type AuditEntityType =
  | 'property' | 'plot' | 'project'
  | 'user' | 'agency' | 'developer' | 'agent'
  | 'report' | 'application';

export type AuditAction =
  | 'approve' | 'reject' | 'feature' | 'unfeature'
  | 'suspend' | 'unsuspend' | 'delete' | 'restore'
  | 'bulk_approve' | 'bulk_reject' | 'bulk_feature' | 'bulk_unfeature'
  | 'role_change' | 'send_feedback'
  | 'report_resolve' | 'report_dismiss' | 'report_investigate'
  | 'merge_duplicate' | 'other';

interface LogParams {
  action: AuditAction | string;
  entity_type: AuditEntityType | string;
  entity_id?: string | null;
  reason?: string;
  metadata?: Record<string, any>;
}

/**
 * Append-only audit log writer. Silently no-ops on failure so it never
 * blocks the underlying admin action.
 */
export async function logAdminAction(params: LogParams): Promise<void> {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return;

    await supabase.from('admin_actions' as any).insert({
      admin_id: user.id,
      action: params.action,
      entity_type: params.entity_type,
      entity_id: params.entity_id ?? null,
      reason: params.reason ?? null,
      metadata: params.metadata ?? null,
    });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('[auditLog] failed to record admin action', err);
  }
}
